import React from "react";

import Box from "@material-ui/core/Box";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import LoadingSpinner from "components/LoadingSpinner";
import { BigScreenView } from "components/SaleWatcher/BigScreenView";
import { DefaultView } from "components/SaleWatcher/DefaultView";
import {
  LastWeighedDetailedView,
  LastWeighedView,
} from "components/SaleWatcher/LastWeighed";
import ModeSwitcher from "components/SaleWatcher/ModeSwitcher";
import {
  OnScalesDetailedView,
  OnScalesView,
} from "components/SaleWatcher/OnScales";
import {
  RingSellingByPriceView,
  RingSellingByWeightView,
  RingSellingByWeightWithBuyerAndBuyerWayView,
  RingSellingByWeightWithBuyerAndBuyerWayViewForDraftingInformation,
  RingSellingByWeightWithNextView,
} from "components/SaleWatcher/RingSelling";
import { SalePreview } from "components/SaleWatcher/SalePreview";
import {
  StudWatcherWithBuyerWayAndVendorView,
  StudWatcherWithBuyerWayView,
  StudWatcherWithVendorView,
} from "components/SaleWatcher/StudWatcher";

import { Settings } from "constants/settings";
import { ViewMode } from "constants/watcher";

import {
  getIsFetchingAuctionPens,
  getIsFetchingProperties,
  getIsFetchingSaleLots,
  getIsFetchingScans,
  getSetting,
} from "selectors";

import "./transitions.css";

import {
  RingSellingBriefByPriceView,
  RingSellingBriefBySoldThenWeight,
  RingSellingBriefByWeightView,
} from "./RingSellingBrief";

// Full height - height of header

const LoadingWrapper = styled.div`
  height: calc(100vh - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FullPage = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const ViewModeComponentMap = {
  [ViewMode.DEFAULT]: DefaultView,
  [ViewMode.RING_SELLING_BY_WEIGHT]: RingSellingByWeightView,
  [ViewMode.RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY]:
    RingSellingByWeightWithBuyerAndBuyerWayView,
  [ViewMode.RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY_FOR_DRAFTING_INFORMATION]:
    RingSellingByWeightWithBuyerAndBuyerWayViewForDraftingInformation,
  [ViewMode.RING_SELLING_BY_PRICE_THEN_WEIGHT]: RingSellingByWeightWithNextView,
  [ViewMode.RING_SELLING_BY_PRICE]: RingSellingByPriceView,
  [ViewMode.RING_SELLING_BRIEF_BY_WEIGHT]: RingSellingBriefByWeightView,
  [ViewMode.RING_SELLING_BRIEF_BY_PRICE_THEN_WEIGHT]:
    RingSellingBriefBySoldThenWeight,
  [ViewMode.RING_SELLING_BRIEF_BY_PRICE]: RingSellingBriefByPriceView,
  [ViewMode.BIG_SCREEN]: BigScreenView,
  [ViewMode.SALE_PREVIEW]: SalePreview,
  [ViewMode.STUD_WATCHER_WITH_VENDOR]: StudWatcherWithVendorView,
  [ViewMode.STUD_WATCHER_WITH_BUYER_WAY]: StudWatcherWithBuyerWayView,
  [ViewMode.STUD_WATCHER_WITH_BUYER_WAY_AND_VENDOR]:
    StudWatcherWithBuyerWayAndVendorView,
  [ViewMode.LAST_WEIGHED]: LastWeighedView,
  [ViewMode.LAST_WEIGHED_DETAILED]: LastWeighedDetailedView,
  [ViewMode.ON_SCALES]: OnScalesView,
  [ViewMode.ON_SCALES_DETAILED]: OnScalesDetailedView,
};

export const SaleWatcher = () => {
  const isLoadingData = useSelector(state => {
    return (
      getIsFetchingSaleLots(state) ||
      getIsFetchingProperties(state) ||
      getIsFetchingAuctionPens(state) ||
      getIsFetchingScans(state)
    );
  });

  const viewMode =
    useSelector(getSetting(Settings.watcherViewMode)) || ViewMode.DEFAULT;

  const DisplayComponent = ViewModeComponentMap[viewMode] || DefaultView;

  return (
    <FullPage>
      {isLoadingData ? (
        <LoadingWrapper item>
          <LoadingSpinner />
        </LoadingWrapper>
      ) : (
        <>
          <DisplayComponent />
          <ModeSwitcher />
        </>
      )}
    </FullPage>
  );
};
